import { createContext } from 'react';

export const VideoModalContext = createContext({
  isOpen: false,
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  setIsOpen: () => { console.log("Default function for VideoModalContext"); },
  setUrl: () => { console.log("Default function for VideoModalContext"); },
});

export const LongFormTextModalContext = createContext({
  isOpen: false,
  title: ' - ',
  markdown: '#Hello World!',
  setIsOpen: () => { console.log("Default function for LongFormTextModalContext"); },
  setTitle: () => { console.log("Default function for LongFormTextModalContext"); },
  setMarkdown: () => { console.log("Default function for LongFormTextModalContext"); }
});

export const MapModalContext = createContext({
  isOpen: false,
  center: {
    lat: 55.8681772,
    lng: -4.2783594
  },
  setIsOpen: () => { console.log("Default function for MapModalContext") },
  setCenter: () => { console.log("Default function for MapModalContext") }
});

export const CommentFormModalContext= createContext({
  isOpen: false,
  postUrl: '',
  setIsOpen: () => { console.log("Default function for CommentFormModalContext"); },
  setPostUrl: () => { console.log("Default function for CommentFormModalContext"); }
});

export const GalleryModalContext = createContext({
  isOpen: false,
  images: [],
  markdownCaptions: [],
  modalStyle: {},
  setIsOpen: () => { console.log("Default function for GalleryModalContext") },
  setImages: () => { console.log("Default function for GalleryModalContext") },
  setMarkdownCaptions: () => { console.log("Default function for GalleryModalContext") },
  setModalStyle: () => { console.log("Default function for GalleryModalContext") },
});

export const PosterModalContext = createContext({
  isOpen: false,
  image: '',
  pdfLink: null,
  linkText: null,
  extraButtons: [],
  zoomPan: true,
  extraWide: false,
  setIsOpen: () => { console.log("Default function for PosterModalContext") },
  setImage: () => { console.log("Default function for PosterModalContext") },
  setPdfLink: () => { console.log("Default function for PosterModalContext") },
  setLinkText: () => { console.log("Default function for PosterModalContext") },
  setExtraButtons: () => { console.log("Default function for PosterModalContext") },
  setZoomPan: () => { console.log("Default function for PosterModalContext") },
  setExtraWide: () => { console.log("Default function for PosterModalContext") },
});

export const CustomFormModalContext = createContext({
  isOpen: false,
  title: '',
  action: '',
  method: 'POST',
  partsConfig: [],
  setIsOpen: () => { console.log("Default function for CustomFormModalContext") },
  setTitle: () => { console.log("Default function for CustomFormModalContext") },
  setAction: () => { console.log("Default function for CustomFormModalContext") },
  setMethod: () => { console.log("Default function for CustomFormModalContext") },
  setPartsConfig: () => { console.log("Default function for CustomFormModalContext") },
});